import React from 'react';
import Fab from '@mui/material/Fab';
import Grid from '@mui/material/Grid';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import CardContent from '@mui/material/CardContent';
import CardActionArea from '@mui/material/CardActionArea';
//UTILS
import axios from '../../../../../../shared/axios/axiosProxy';
//REDUX
import ACTIONS from '../../../../../../redux/action';
import { connect } from 'react-redux';
import { Avatar } from '@mui/material';
import ProfileIconDefaultAvatar from '../../../../../images/profile-icon-default-avatar.svg';

const mapStateToProps = (state) => ({
	provider_media: state.provider_media,
	providerID: state.providerID,
});
const mapDispatchToProps = (dispatch) => ({
	addProviderInfo: (item) => dispatch(ACTIONS.addProviderInfo(item)),
});

class ImageUpload extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			mainState: 'initial', // initial, search, gallery, uploaded
			imageUploaded: 0,
			selectedFile: ProfileIconDefaultAvatar,
		};
	}

	componentDidMount() {
		if (this.props.provider_media.profileImage) {
			this.setState({
				mainState: 'uploaded',
				selectedFile: this.props.provider_media.profileImage,
				imageUploaded: 1,
			});
		} else {
			this.setState({
				mainState: 'initial',
				imageUploaded: 0,
				selectedFile: ProfileIconDefaultAvatar,
			});
		}
	}

	fileInputRef = React.createRef();

	static handleCustomButtonClick = () => {
		if (this.fileInputRef.current) {
			this.fileInputRef.current.click();
		}
	};

	handleUploadClick = (event) => {
		var file = event.target.files[0];
		const reader = new FileReader();
		/* eslint-disable no-unused-vars */
		var url = reader.readAsDataURL(file);
		/* eslint-disable no-unused-vars */
		reader.onloadend = function (e) {
			this.setState({
				selectedFile: [reader.result],
			});
			this.props.addProviderInfo({
				id: 'profileImage',
				data: `https://knet-profile-images.s3.eu-west-1.amazonaws.com/profile_${this.props.providerID}`,
				stateObject: 'provider_media',
			});
			const JWT = localStorage.getItem('JWT');
			axios
				.patch(
					'/api/provider/picture',
					{
						provider_media: {
							profileImage: `https://knet-profile-images.s3.eu-west-1.amazonaws.com/profile_${this.props.providerID}`,
						},
						image: reader.result,
					},
					{
						headers: {
							Authorization: `Bearer ${JWT}`,
							'Content-Type': 'application/json',
						},
					}
				)
				.then((response) => {
					console.log('AXIOS RESPONSE: ', response);
				})
				.catch((error) => {
					console.log('AXIOS ERROR: ', error.response.data);
				})
				.catch((error) => console.log('submitToDB error', error));
		}.bind(this);

		this.setState({
			mainState: 'uploaded',
			selectedFile: event.target.files[0],
			imageUploaded: 1,
		});
	};

	renderUploadedState() {
		return (
			<React.Fragment>
				{/* <CardActionArea onClick={this.imageResetHandler}> */}
				{/* <img className="user-logo" src={this.state.selectedFile} alt="user" /> */}
				<Avatar
					src={this.state.selectedFile || ProfileIconDefaultAvatar}
					alt="user"
					sx={{ width: 120, height: 120, objectFit: 'cover' }}
				/>
				{/* </CardActionArea> */}
			</React.Fragment>
		);
	}
	imageResetHandler = (event) => {
		this.setState({
			mainState: 'initial',
			selectedFile: null,
			imageUploaded: 0,
		});
	};
	renderInitialState() {
		/*  const { value } = this.state; */
		return (
			// <React.Fragment>
			//   <CardContent>
			//     <Grid container justifyContent="center" alignItems="center">
			//       <input
			//         className="imageUpload"
			//         accept="image/*"
			//         id="contained-button-file"
			//         multiple
			//         type="file"
			//       // onChange={this.handleUploadClick}
			//       />
			//       {/* <label htmlFor="contained-button-file">
			//         <Fab component="span">
			//           <AddPhotoAlternateIcon />
			//         </Fab>
			//       </label> */}
			//     </Grid>
			//   </CardContent>
			// </React.Fragment>
			<Avatar
				src={ProfileIconDefaultAvatar}
				alt="user"
				sx={{ width: 120, height: 120, objectFit: 'cover' }}
			/>
		);
	}
	render() {
		return (
			<>
				<input
					ref={this.fileInputRef}
					id="file-upload-image"
					type="file"
					style={{ display: 'none' }}
					accept="image/*"
					onChange={this.handleUploadClick}
				/>
				<Grid
					container
					justifyContent="center"
					alignItems="center"
					className="imageUploadContainer">
					{(this.state.mainState === 'initial' && this.renderInitialState()) ||
						(this.state.mainState === 'uploaded' && this.renderUploadedState())}
				</Grid>
			</>
		);
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(ImageUpload);
